import ConfirmModalComponent from "@/components/sharedComponents/confirm/confirm.component";
import { policyList } from "@/enums/permissions";
import { AccountManagement } from "@/interfaces/accountManagement";
import accountServices from "@/services/account.services";
import { BooleanCheck, PageTitleComponent } from "helix-vue-components";
import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import Template from "./AccountCreditCards.template.vue";
import CreditCardsListComponent from "./CreditCardList/CreditCardsList.component";

@Component({
  mixins: [Template],
  components: {
    PageTitleComponent,
    "credit-cards-list": CreditCardsListComponent
  }
})
export default class AccountCreditCards extends Vue {
  @Getter("user", { namespace: "authModule" })
  public user!: any;
  @Getter("hasPermission", { namespace: "authModule" })
  public hasPermission!: BooleanCheck;
  public openedForm: boolean = false;

  public cards: AccountManagement.CreditCard[] = [];
  public selected: AccountManagement.CreditCard | null = null;
  public viewDetail: boolean = false;
  public actions = { canAdd: false, canDelete: false, canEdit: false };
  public loadingCards = false;
  protected policyList = policyList;

  public removeCard(card: AccountManagement.CreditCard) {
    this.$modals
      .load<boolean>(
        ConfirmModalComponent,
        {
          size: "small"
        },
        {
          modalData: {
            title: "delete_card",
            body: "delete_card_msg",
            bodyParams: { card: card.nickname },
            icon: "fal fa-exclamation-triangle"
          }
        }
      )
      .then(
        async () => {
          const response = await accountServices.deleteCreditCard(
            this.user.settings.current_account_id,
            card.id
          );

          if (response) {
            this.loadCards();
          }
        },
        () => {
          /** Nothing to do */
        }
      );
  }

  protected async loadCards() {
    this.loadingCards = true;
    this.cards = await accountServices.getCreditCards(
      this.user.settings.current_account_id
    );
    this.loadingCards = false;
  }

  protected mounted() {
    this.loadCards();
    this.actions = {
      canDelete: this.hasPermission(this.policyList.deleteCreditCards),
      canEdit: this.hasPermission(this.policyList.modifyCreditCards),
      canAdd: this.hasPermission(this.policyList.createCreditCards)
    };
  }
}
